import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'widget-invoicing',
  templateUrl: './widget-invoicing.component.html',
  styleUrls: ['./widget-invoicing.component.scss']
})
export class WidgetInvoicingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
